export default __webpack_public_path__ + "static/media/kuchynka.9412028a.jpeg";